import { InputHTMLAttributes } from 'react'
import cx from 'classnames'
import { FormikErrors } from 'formik'

import { PasswordInput } from '../PasswordInput'

import './style.scss'

export type Input = Omit<
  InputHTMLAttributes<
    HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
  >,
  'size'
> & {
  label?: string
  icon?: 'search'
  onClickIcon?: () => void
  error?: string | string[] | FormikErrors<any> | FormikErrors<any>[]
  as?: 'input' | 'select' | 'textarea'
  fullWidth?: boolean
  size?: 'small' | 'medium'
  hideError?: boolean
  rows?: number
}

export const Input = ({
  className = '',
  label,
  icon,
  onClickIcon = () => {},
  error,
  as = 'input',
  fullWidth = true,
  size = 'medium',
  hideError = false,
  ...props
}: Input) => {
  const Elm = props.type === 'password' ? PasswordInput : as

  return (
    <span
      className={cx(
        'FormInput',
        !fullWidth && 'FormInput--no-full-width',
        className
      )}
    >
      {label && <label className="FormInput__label">{label}</label>}

      <Elm
        className={cx('FormInput__input', `FormInput__input--${size}`)}
        {...props}
      />

      {!hideError && error && <span className="FormInput__error">{error}</span>}

      {icon && (
        <span
          className={cx(
            'FormInput__icon',
            `FormInput__icon--${icon}`,
            onClickIcon && 'FormInput__icon--clickable'
          )}
          onClick={onClickIcon}
          role={onClickIcon && 'button'}
        />
      )}
    </span>
  )
}
